import { SubstitutionPartsParamsType } from '@/common/queries/selections/substitutionParts/substitutionParts.type';
import { substitutionPartsFunction } from '@/common/queries/selections/substitutionParts/substitutionPartsFunction';
import { queryOptions } from '@tanstack/react-query';

export const substitutionPartsOption = (param: SubstitutionPartsParamsType) =>
  queryOptions({
    queryKey: ['get_substitution_part', param],
    queryFn: () => substitutionPartsFunction(param),
    select: (data) =>
      data?.map((item) => ({ value: item?.id, label: item?.name })),
    enabled: param.enabled,
  });
